import { render, staticRenderFns } from "./VideoPractice.vue?vue&type=template&id=4ddcd7d4&scoped=true&"
import script from "./VideoPractice.vue?vue&type=script&lang=js&"
export * from "./VideoPractice.vue?vue&type=script&lang=js&"
import style0 from "./VideoPractice.vue?vue&type=style&index=0&id=4ddcd7d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddcd7d4",
  null
  
)

export default component.exports